import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionFigureCaption as r } from "../types/HostActionFigure.mjs";
import { HostActionTargetKind as i } from "../types/HostActionTarget.mjs";
import { parseAmount as a } from "@maat/currency";
//#region src/mappers/toFinanceActions.ts
var o = (o) => o ? (o.outstanding_debts ?? []).flatMap((s) => {
	let c = a(s.amount);
	if (c === void 0 || c <= 0) return [];
	let l = (o.debts ?? []).filter((e) => e.currency === s.currency);
	return [{
		id: `${e.PenaltyDebt}:${o.workspace_id}:${s.currency}`,
		type: e.PenaltyDebt,
		intent: t.Blocker,
		params: { count: l.length },
		facets: l.length ? [{
			kind: n.Count,
			count: l.length
		}] : void 0,
		figure: {
			amount: c,
			currency: s.currency,
			caption: r.Outstanding
		},
		weight: c,
		target: { kind: i.Penalties }
	}];
}) : [], s = (n, o) => !n || o === void 0 ? [] : (n.balances ?? []).flatMap((s) => {
	let c = a(s.available_balance);
	return c === void 0 || c <= 0 || o.some((e) => e.currency === s.currency) ? [] : [{
		id: `${e.PayoutMethodMissing}:${n.workspace_id}:${s.currency}`,
		type: e.PayoutMethodMissing,
		intent: t.Blocker,
		figure: {
			amount: c,
			currency: s.currency,
			caption: r.Available
		},
		weight: c,
		target: { kind: i.WithdrawalMethods }
	}];
}), c = (r) => r.filter((e) => e.status === "REJECTED").map((r) => {
	let o = a(r.amount);
	return {
		id: `${e.PayoutRejected}:${r.id}`,
		type: e.PayoutRejected,
		intent: t.Blocker,
		facets: r.notes ? [{
			kind: n.Text,
			text: r.notes
		}] : void 0,
		figure: o === void 0 ? void 0 : {
			amount: o,
			currency: r.currency
		},
		createdAt: r.created_at,
		weight: o ?? 0,
		target: { kind: i.Withdrawals }
	};
});
//#endregion
export { o as toDebtActions, s as toPayoutMethodActions, c as toRejectedPayoutActions };
